
// 0 = user, 1 = admin
import {InputError} from "./security";

export enum UserRole {
  Protester = 1,
  Intervenor,
  GAO_Attorney,
  Secondary_Protester,
  Agency_Admin,
  Agency_Attorney,
  GAO_Admin,
  GAO_Supervisor,
  Secondary_Intervenor

}

export const UserRoleString: string[] =
  ['',  // dummy string since EPDS user roles start at 1
  'user', //'Protester',
  'user', //'Intervenor',
  'user', //'GAO_Attorney',
  'user', //'Secondary_Protester',
  'user', //'Agency_Admin',
  'user', //'Agency_Attorney',
  'admin', //'GAO_Admin',
  'user', //'GAO_Supervisor',
  'user', //'Secondary_Intervenor'
];  // better way to do this??  only role 7 is allowed into admin area


// 0 = new reg, 1 = denied, 2 = active, 3 = disabled
export enum UserStatus {
  New = 1,
  Active = 2,
  Temporary = 3,
  Locked = 4,
  Expired = 5,
  Deactive = 6,
  Reset = 7,
  TempPass = 8
}

export interface User {
  aNumNotifications: string,
  account_status: string,
  account_status_id: UserStatus,
  address1?: string,
  address2?: string,
  city?: string,
  country?: string,
  editable: string,
  email: string,
  fax_No: string,
  firm_Name: string,
  firm_id: number,
  first_Name: string,
  gao_user_id: string,
  globalEmailPref: string,
  group_No: string,
  intervenorCompanyDetail: string,
  intervenorCompanyInfo: IntervenorCompanyInfo,
  intervenor_Company_Address: string,
  intervenor_Company_Name: string,
  invitationStatus: string,
  last_Name: string,
  middle_initial: string,
  old_email: string,
  phone_No: string,
  po: string,
  prefix: string,
  role: string,
  role_id: UserRole,
  state?: string,
  street?: string,
  suffix: string,
  title: string,
  user_Id: string,
  zip_Code?: string
}

export interface IntervenorCompanyInfo {
  companyAddress?: string;
  companyDetail?: string;
  companyName: string;
  intervenorFileId?: number;
}

export const UserMaxLen: any = {
  address1: 100,
  address2: 100,
  city: 25,
  country: 25,
  email: 320,
  fax_No: 25,
  firm_Name: 200,
  first_Name: 25,
  gao_user_id: 10,
  group_No: 10,
  last_Name: 25,
  middle_initial: 1,
  password: 25,
  phone_No: 25,
  prefix: 10,
  state: 25,
  street: 255,
  suffix: 10,
  title: 255,
  user_Id: 25,
  zip_Code: 25
}

export interface LoginResponse {
  isLoginSuccess: boolean,
  message: string,
  data: User,
  dto: UserInfoDto,
  displayPopup: boolean,
  popupHtml: string
}

export interface MessageResponse {
  message: string
}

export interface GaoUserResponse {
  gao_User_Info_List: User[],
}

export interface UserProfileResponse {
  user_Info: User,
  user_Role: UserRole,
}

export interface DeleteUserResponse {
  authorized: boolean;
  isSuccess: boolean;
}

export interface UserInfoDto {
  isROBRequired: boolean,
  account_status_id: number,
  numOfDaysLeftToExpirePwd: number,
  passwordExpiring: boolean,
  passwordExpired: boolean
}

export const USER_INIT: User = {
  aNumNotifications: "",
  account_status: "",
  account_status_id: UserStatus.New,
  address1: "",
  address2: "",
  city: "",
  country: "",
  editable: "",
  email: "",
  fax_No: "",
  firm_Name: "",
  firm_id: 0,
  first_Name: "",
  gao_user_id: "",
  globalEmailPref: "",
  group_No: "",
  intervenorCompanyDetail: "",
  intervenorCompanyInfo: { companyName: '' },
  intervenor_Company_Address: "",
  intervenor_Company_Name: "",
  invitationStatus: "",
  last_Name: "",
  middle_initial: "",
  old_email: "",
  phone_No: "",
  po: "",
  prefix: "",
  role: "",
  role_id: UserRole.Protester,
  state: "",
  street: "",
  suffix: "",
  title: "",
  user_Id: "",
  zip_Code: ""
};

export interface ValidateNewUser {
  isSuccess: boolean,
  inputErrors: InputError[]
}
